import type { FeatureFlagsService } from '@inato/browser-feature-flags';
import { useFeatureFlag as _useFeatureFlag } from '@inato/browser-feature-flags';

import type { FeatureFlag } from '../../../application/FeatureFlag';
import { makeContext } from '../makeContext';

export const {
  Provider: FeatureFlagsServiceProvider,
  useContext: useFeatureFlagsService,
} = makeContext<FeatureFlagsService<FeatureFlag>>('FeatureFlagsService');

export const useFeatureFlag = (name: FeatureFlag) => {
  const featureFlagsService = useFeatureFlagsService();
  return _useFeatureFlag({ name, featureFlagsService });
};
